import { NextSeo } from 'next-seo'
import EventJsonLd from 'seo/EventJsonLd'
import React from 'react'
import { useEventContext } from 'context/EventContext'
import EventAssets from 'components/events/EventAssets'
import { EventFormat, useCollectiveQuery } from 'graphql/generated'
import CollectivePageHeader from 'components/Collectives/Common/CollectivePageHeader/CollectivePageHeader'
import EventThumbnail from './EventThumbnail'
import EventButtons from './EventButtons/EventButtons'
import EventDetails from './EventDetails'
import classNames from 'classnames'
import Map from 'components/Map/Map'
import ContentWrapper from 'components/ContentWrapper'

const Event: React.FC = () => {
  const { event } = useEventContext()

  const { data } = useCollectiveQuery({
    variables: {
      collectiveId: event.collective?.id || '',
      proposalConnection: { first: 5 }
    },
    skip: !event.collective,
    nextFetchPolicy: 'cache-first'
  })

  const isRenderThumbSection = event.thumb || event.canEdit
  const ogImageUrl = event.thumb || event.ogImageUrl

  return (
    <ContentWrapper>
      <NextSeo
        openGraph={{
          url: event.publicUrl,
          images: ogImageUrl
            ? [
                {
                  url: ogImageUrl,
                  width: 2048,
                  height: 1077
                }
              ]
            : []
        }}
        twitter={{
          cardType: 'summary_large_image'
        }}
        additionalMetaTags={[
          {
            name: 'twitter:image',
            content: ogImageUrl || 'https://upstreamapp.com/static/robot.png'
          },
          {
            name: 'twitter:image:alt',
            content: 'Event flyer'
          }
        ]}
      />
      <EventJsonLd />

      {data && data.collective && (
        <CollectivePageHeader collective={data.collective} />
      )}

      <div className="block md:flex md:flex-row-reverse flex-wrap relative">
        {isRenderThumbSection && (
          <div className="flex-[3_3_0%] flex flex-col lg:max-w-[650px] px-4 pt-4">
            <EventThumbnail event={event} />

            {/* Show buttons if can add thumb or has thumb on big screen */}
            <div className="hidden md:block">
              <EventButtons />
            </div>
          </div>
        )}

        <div
          className={
            'p-4 flex-[2_2_0%] flex flex-col justify-start space-y-4 border-t sm:border-t-0 mt-4 sm:mt-0'
          }
        >
          <EventDetails />

          {/* Show buttons at end if no image is added and not allowed or if mobile (since right side section wont render) */}
          <div
            className={classNames(
              isRenderThumbSection && 'md:hidden',
              'sticky z-40 bottom-0 bg-white border-t border-gray-300'
            )}
          >
            <EventButtons />
          </div>
        </div>
      </div>

      <EventAssets />

      {event.geolocation && event.format == EventFormat.IN_PERSON && (
        <div className="mt-2 px-4 pb-4">
          <Map
            lat={event.geolocation.latitude}
            lng={event.geolocation.longitude}
            label={event.location || 'Here'}
          />
        </div>
      )}
    </ContentWrapper>
  )
}

export default Event
